import React, { useEffect } from 'react';
import { compose, withHandlers, withProps, defaultProps } from 'recompose';
import { DISPLAY_MODE, GAME_SIZES } from 'js/components/common/GamesView/constants';
import Game from './GameItem';
import { pick, prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';
import { GamesView } from 'js/components/common/GamesView';
import style from './index.scss';
import { useSmartClosePopups } from 'js/components/common/PopupManager';

export const SLIDER_OPTIONS = {
    animation: {
        type: 'monoSlider'
    },
    isExpandedCategoryPopup: true,
    controls: {
        arrows: { enabled: false },
        bullets: { enabled: false },
        buttons: { enabled: false }
    }
};

export const Category = ({
                             gameCodes,
                             setCategoryRef,
                             scrollIntoView,
                             className = '',
                             onActiveSlideChange,
                             cid,
                             categoryName,
                             mostPlayedGame
                         }) => {
    const categoryClsName = [
        className,
        style.category
    ].filter(Boolean).join(' ');
    const favoriteGames = useAppSelector(prop('favoriteGames'));
    const favorite = favoriteGames && favoriteGames.filter(code => gameCodes.includes(code));
    const isFavoriteCategory = cid === 'favorites';
    const codes = isFavoriteCategory ? favorite : gameCodes;
    const closePopups = useSmartClosePopups();

    useEffect(() => {
        if (isFavoriteCategory && !favorite.length) {
            closePopups();
        }
    }, [closePopups, isFavoriteCategory, favorite]);

    return (
        <div ref={setCategoryRef} className={categoryClsName}>
            <GamesView
                category={cid}
                displayMode={DISPLAY_MODE.GRID}
                gameSize={GAME_SIZES.MEDIUM}
                gameCodes={codes}
                scrollIntoView={scrollIntoView}
                onActiveSlideChange={onActiveSlideChange}
                Game={Game}
                sliderOptions={SLIDER_OPTIONS}
                categoryName={categoryName}
                mostPlayedGame={mostPlayedGame}
            />
        </div>
    );
};

export default compose(
    defaultProps({ showTitle: true }),
    withProps(() => useAppSelector(pick(['headerHeight']))),
    withHandlers(() => {
        let categoryRef;

        return {
            setCategoryRef: () => ref => categoryRef = ref,
            scrollIntoView: ({ headerHeight }) => () => {
                const { documentElement, body } = document;
                const { top: categoryTop } = categoryRef.getBoundingClientRect();
                const top = categoryTop + (documentElement.scrollTop || body.scrollTop) - headerHeight;

                window.scrollTo(0, top);
            }
        };
    })
)(Category);
